export class VerticalUnsupportedError extends Error {}
